/*!

=========================================================
* Footer
=========================================================

*/
import React from "react";

// reactstrap components
import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";

function Footer() {
    return (
        <>
            <Container fluid>
                <footer className="footer pt-0">
                    <Row className="align-items-center justify-content-lg-between">
                        <Col lg="6">
                            <div className="copyright text-center text-lg-left text-muted">
                                © {new Date().getFullYear()}{" "}
                                <a
                                    className="font-weight-bold ml-1"
                                    href="https://pefoods.com.au"
                                    target="_blank"
                                >
                                    PE Foods
                                </a>
                            </div>
                        </Col>
                        <Col lg="6">
                            <Nav className="nav-footer justify-content-center justify-content-lg-end">
                                <NavItem>
                                    <NavLink
                                        href="https://web.bird.digital"
                                        target="_blank"
                                    >
                                        App by Web Bird Digital
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        href="https://pefoods.com.au"
                                        target="_blank"
                                    >
                                        Terms &amp; Conditions
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </Col>
                    </Row>
                </footer>
            </Container>
        </>
    );
}

export default Footer;
